module.exports = __webpack_public_path__ + "img/d4883df.jpg";